import { getUrlParams } from "../../services/service-url-params";
import { openLogin } from "../../services/service-login";
export default class EventSignup {
  constructor(element) {
    this.el = element;
    this.isAuth = this.el.dataset.isauth;
    this.activateButtons = document.querySelectorAll("[data-activator]");
    this.loginButtons = document.querySelectorAll("[data-loginbutton]");
    this.loginPopup = document.querySelector("[data-loginpopup]");
    this.slides = this.el.querySelectorAll("[data-slidenr]");
    this.headline = this.el.querySelector("[data-headline]");
    this.dateSlide = this.el.querySelector("[date-slide='date']");
    this.SlideHeader = this.el.querySelector("[data-headline]");
    this.infoSlide = this.el.querySelector("[date-slide='info']");
    this.receiptSlide = this.el.querySelector("[date-slide='receipt']");
    this.stepShowOne = this.el.querySelector("[data-stepshow='1']");
    this.stepShowTwo = this.el.querySelector("[data-stepshow='2']");
    this.StepShowThree = this.el.querySelector("[data-stepshow='3']");
    this.closeButton = this.el.querySelector("[data-buttonclose]");
    this.setseats = this.infoSlide.querySelector("[data-setseats]");
    this.receiptTextContainer = this.receiptSlide.querySelector(".receipt-text");
    this.waitinglistTextContainer = this.receiptSlide.querySelector(".watinglist-text");
    this.buttons = this.el.querySelectorAll("button");
    this.form = this.el.querySelector("form");
    this.dates = this.dateSlide.querySelectorAll(".dateinput");
    this.dateButton = this.dateSlide.querySelector("button");
    this.submitButton = this.infoSlide.querySelector("[data-submit]");
    this.infoBackButton = this.infoSlide.querySelector("[data-backbutton]");
    this.eventbox = document.querySelectorAll("[data-eventboxid]");
    this.closeSignupButton = this.receiptSlide.querySelector("[data-closebutton]");
    this.errorText = this.el.dataset.errortxt;
    this.eventList = this.el.querySelectorAll("[data-event]");
    this.maxSeats;
    this.setMaxSeats = this.setMaxSeats.bind(this);
    this.setHeight = this.setHeight.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.inputInfo = this.inputInfo.bind(this);
    this.isValid = this.isValid.bind(this);
    this.closeSignup = this.closeSignup.bind(this);
    this.openSignup = this.openSignup.bind(this);
    this.setDate = this.setDate.bind(this);
    this.submitRegistration = this.submitRegistration.bind(this);
    this.moveToReceipt = this.moveToReceipt.bind(this);
    this.resetButton = this.resetButton.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateEmail = this.updateEmail.bind(this);

    this.init();
  }

  init() {
    let params = getUrlParams();
    
    if (this.loginButtons) {
      this.loginButtons.forEach((loginbutton) => {
        let disabled = loginbutton.dataset.isDisabled;
        if (disabled === "True") {
          loginbutton.classList.add("cursor-not-allowed");
          loginbutton.classList.add("opacity-50");
          loginbutton.classList.add("hover:bg-blue");
          //remove href from loginbutton
          loginbutton.removeAttribute("href");
        }
      });
    }

    this.eventbox.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        let memberOnly = button.dataset.boxmember;
        let isSignedUp = button.dataset.issignedup;
        if (isSignedUp === "True") {
          return;
        }
        if (memberOnly === "True" && this.isAuth === "False") {
          this.loginButtons.forEach((loginbutton) => {
            loginbutton.classList.add("animate-pulse");
            setTimeout(() => {
              loginbutton.classList.remove("animate-pulse");
            }, 2000);
          });
          return;
        } else {
          let buttonID = button.dataset.eventboxid;
          this.el.classList.remove("hidden");
          this.setHeight();
          if (buttonID != undefined) {
            this.setDate(buttonID);
          }
        }
      });
    });

    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        console.log("e: ", e);
        e.preventDefault();
      });
    });

    this.form.addEventListener("change", (e) => {
      e.preventDefault();
    });
    this.selectDate();
    this.inputInfo();
    this.openSignup(params);
    this.closeSignup();
  }

  setMaxSeats(seats) {
    console.log('seats: ', seats)
    this.setseats.value = 1;
    if (seats != "0") {
      this.setseats.max = seats;
    } else {
      this.setseats.max = "";
    }
  }

  openSignup(params) {
    if (this.activateButtons) {
      this.activateButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          this.el.classList.remove("hidden");
          this.setHeight();
          if (params.date != undefined) {
            this.setDate(params.date);
          }
        });
      });
    }
  }

  setDate(id) {
    this.dates.forEach((date) => {
      if (date.dataset.id == id) {
        this.setMaxSeats(date.dataset.max);
        date.checked = true;
        this.dateButton.disabled = false;
      }
    });
  }

  closeSignup() {
    this.closeButton.addEventListener("click", (e) => {
      this.el.classList.add("hidden");
      this.dateSlide.classList.remove("hidden");
      this.dateSlide.classList.remove("-translate-x-full");
      this.infoSlide.classList.add("-translate-x-full");
      this.infoSlide.classList.remove("hidden");
      this.receiptSlide.classList.add("-translate-x-full");
      this.stepShowOne.classList.add("border-b-4");
      this.stepShowTwo.classList.remove("border-b-4");
      this.StepShowThree.classList.remove("border-b-4");
      this.form.reset();
      location.reload();
    });
    this.closeSignupButton.addEventListener("click", (e) => {
      this.el.classList.add("hidden");
      this.dateSlide.classList.remove("hidden");
      this.dateSlide.classList.remove("-translate-x-full");
      this.infoSlide.classList.add("-translate-x-full");
      this.infoSlide.classList.remove("hidden");
      this.receiptSlide.classList.add("-translate-x-full");
      this.stepShowOne.classList.add("border-b-4");
      this.stepShowTwo.classList.remove("border-b-4");
      this.StepShowThree.classList.remove("border-b-4");
      this.form.reset();
      location.reload();
    });
  }

  setHeight() {
    let headerHeight = this.SlideHeader.offsetHeight;
    let modalHeight = 300;
    this.slides.forEach((slide) => {
      //Height + headline height
      //let fullHeight = slide.offsetHeight + this.headline.offsetHeight;
      let fullHeight = slide.offsetHeight + headerHeight;

      if (fullHeight > modalHeight) {
        modalHeight = fullHeight;
      }
    });

    this.el.style.height = modalHeight + "px";
    this.slides.forEach((slide) => {});
  }

  selectDate() {
    if (this.dates) {
      this.dates.forEach((date) => {
        date.addEventListener("change", (e) => {
          this.setMaxSeats(date.dataset.max);
          this.dateButton.disabled = false;
        });
      });
    }

    this.dateButton.addEventListener("click", (e) => {
      if (this.eventList){
        this.eventList.forEach(event => {
          if (event.checked & event.dataset.vacancyOnDate > 0){
            console.log('All seat data: ', event.dataset.vacancyOnDate, event.dataset.max)
            console.log("vacancyondate >= max: ", Number(event.dataset.vacancyOnDate) >= Number(event.dataset.max));
            this.maxSeats =  Number(event.dataset.vacancyOnDate) >= Number(event.dataset.max) && Number(event.dataset.max) > 0 ? Number(event.dataset.max) : Number(event.dataset.vacancyOnDate);
            console.log('this.maxSeats: ', this.maxSeats)
            this.setMaxSeats(this.maxSeats);
          }
        });
      }
      this.dateSlide.classList.add("-translate-x-full");
      this.dateSlide.classList.add("hidden");
      this.infoSlide.classList.remove("-translate-x-full");
      this.stepShowOne.classList.remove("border-b-4");
      this.stepShowTwo.classList.add("border-b-4");
    });
  }

  inputInfo() {
    let inputFields = this.infoSlide.querySelectorAll("[required]");
    let receiptButton = this.infoSlide.querySelector("[data-datebutton]");
    let backButton = this.infoSlide.querySelector("[data-backbutton]");
    
    backButton.addEventListener("click", (e) => {
      this.infoSlide.classList.add("-translate-x-full");
      this.dateSlide.classList.remove("-translate-x-full");
      this.dateSlide.classList.remove("hidden");
      this.stepShowTwo.classList.remove("border-b-4");
      this.stepShowOne.classList.add("border-b-4");
    });

    if (inputFields) {
      inputFields.forEach((field) => {
        field.addEventListener("change", (e) => {
          if (this.isValid(inputFields)) {
            receiptButton.disabled = false;
          } else {
            receiptButton.disabled = true;
          }
        });
        field.addEventListener("keyup", (e) => {
          if (this.isValid(inputFields)) {
            receiptButton.disabled = false;
          } else {
            receiptButton.disabled = true;
          }
        });
      });
    }

    receiptButton.addEventListener("click", (e) => {
      //change receiptButton to a spinner on click
      backButton.style.visibility = "hidden";
      receiptButton.style.visibility = "hidden";
      receiptButton.nextElementSibling.style.visibility = "visible";
      let activeDate = this.dateSlide.querySelector(".dateinput:checked");
      let spots = this.infoSlide;
      this.submitRegistration(activeDate, this.setseats.value);
    });
  }

  moveToReceipt(status, waitinglist, event) {
    this.resetButton(this.infoBackButton, false);
    this.resetButton(this.submitButton, true);
    if (status == 201) {
      if (waitinglist === "True") {
        this.waitinglistTextContainer.classList.remove("hidden");
        this.waitinglistTextContainer.innerText = this.waitinglistTextContainer.innerText.replace("$adresse", event.dataset.address);
      } else {
        this.receiptTextContainer.classList.remove("hidden");
        this.receiptTextContainer.innerText = this.receiptTextContainer.innerText.replace("$adresse", event.dataset.address);
      }
    } else {
      this.waitinglistTextContainer.classList.remove("hidden");
      this.waitinglistTextContainer.innerText = this.errorText;
    }
    this.infoSlide.classList.add("-translate-x-full");
    this.infoSlide.classList.add("hidden");
    this.receiptSlide.classList.remove("-translate-x-full");
    this.stepShowTwo.classList.remove("border-b-4");
    this.StepShowThree.classList.add("border-b-4");
  }

  updatePhone(phone) {
    var requestOptions = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: phone,
      redirect: "follow",
    };
    console.log("body: ", requestOptions);
    fetch(`/api/memberdata/UpdatePhone`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log("Update phoen result: ",result))
      .catch((error) => console.log("error", error));
  }

   updateEmail(email) {
    var requestOptions = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: email,
      redirect: "follow",
    };
    console.log("body: ", requestOptions);
    fetch(`/api/memberdata/UpdateEmail`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log("update email result:", result))
      .catch((error) => console.log("error", error));
  }

  submitRegistration(event, spots) {
    let waitinglist = event.dataset.watinglist;

    if (this.isAuth == "True") {
      let memberEmail = this.infoSlide.querySelector("#email").dataset.memberemail;
      let memberPhone = this.infoSlide.querySelector("#phone").dataset.memberphone;

      if (memberEmail != this.infoSlide.querySelector("#email").value) {
        console.log('memberEmail: ', memberEmail, this.infoSlide.querySelector("#email").value)
        this.updateEmail(this.infoSlide.querySelector("#email").value);
      }

      if (memberPhone != this.infoSlide.querySelector("#phone").value) {
        console.log('memberPhone: ', memberPhone, this.infoSlide.querySelector("#phone").value)
        this.updatePhone(this.infoSlide.querySelector("#phone").value);
      }

      let fetchUrl = `/api/registration/SubmitMember?eventid=${parseInt(event.dataset.id)}&spots=${parseInt(spots)}${waitinglist == "True" ? `&waitinglist=true` : ``}`;
      var raw = "";

      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(fetchUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          this.moveToReceipt(result.statusCode, waitinglist, event);
        })
        .catch((error) => console.log("error", error));
    } else {
      let firstNameInput = this.infoSlide.querySelector("#name");
      let lastNameInput = this.infoSlide.querySelector("#surname");
      let emailInput = this.infoSlide.querySelector("#email");
      let phoneInput = this.infoSlide.querySelector("#phone");
      let fetchUrl = `/api/registration/Submit?eventid=${parseInt(event.dataset.id)}&firstName=${firstNameInput.value}&lastName=${lastNameInput.value}&email=${emailInput.value}&phone=${phoneInput.value}&spots=${parseInt(spots)}${waitinglist == "True" ? `&waitinglist=true` : ``}`;

      var raw = "";

      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(fetchUrl, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          this.moveToReceipt(result.statusCode, waitinglist, event);
        })
        .catch((error) => console.log("error", error));
    }
  }

  isValid(inputFields) {
    let valid = true;
    inputFields.forEach((field) => {
      if (!field.validity.valid) {
        valid = false;
      }
    });

    return valid;
  }

  resetButton(button, reset) {
    button.style.visibility = "visible";
    if (reset) {
      button.nextElementSibling.style.visibility = "hidden";
    }
  }
}
